import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formazione',
  templateUrl: './formazione.component.html',
  styleUrls: ['./formazione.component.css']
})
export class FormazioneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
